import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

const getWeekDayColor = (weekday: number, isToday: boolean) => {
  if (isToday) return defaultTheme.color.white;
  switch (weekday) {
    case 0:
      return '#F23061';
    case 6:
      return '#00A3D9';
    default:
      return defaultTheme.color.secondary;
  }
};

export const TableData = styled.td(
  (props: { weekday: number; isToday: boolean }) =>
    mq({
      fontSize: defaultTheme.font.size.s,
      textAlign: 'center',
      padding: defaultTheme.spacing.s,
      borderTop: `1px solid ${defaultTheme.border.color.black}`,
      borderLeft: `1px solid ${defaultTheme.border.color.mediumGray}`,
      borderBottom: `1px solid ${defaultTheme.border.color.black}`,
      color: getWeekDayColor(props.weekday, props.isToday),
      fontWeight: props.isToday && 'bold',
      backgroundColor: props.isToday && '#E65C7E',
      '&:first-of-type': {
        borderLeft: 'inherit',
      },
      '& > div:first-of-type': {
        marginBottom: defaultTheme.spacing.s,
      },
      // SafariではBorderTopとBorderBottomが上に表示されてしまうため、doubleで表示するようにする
      '@media not all and (min-resolution:.001dpcm)': {
        '@supports (-webkit-appearance:none)': {
          borderTop: `1px double ${defaultTheme.border.color.black} !important`,
          borderBottom: `1px double ${defaultTheme.border.color.black} !important`,
        },
      },
    }),
);
